export const experiences = [
  {
    title: "AI Engineer / Fullstack Developer",
    company: "Goku Agency",
    time: "Apr 2026 - Present",
    description: [
      "Design, build, and deploy production-grade internal AI Agents integrated with Lark, automating and optimizing company-wide workflows.",
      "Build custom AI tools for internal use to improve developer productivity and operational efficiency.",
      "Develop end-to-end full-stack client web applications featuring sophisticated AI integrations (Gemini/GPT API, agentic workflows).",
      "Scope of work: AI Agent architecture, LLM orchestration, Lark integrations, and fullstack frontend/backend engineering.",
    ],
  },
  {
    title: "Fullstack Developer",
    company: "Goku Agency",
    time: "Aug 2024 - Apr 2026",
    description: [
      "Developed and maintained full-stack web applications and 360° marketing websites for multiple clients.",
      "Built responsive frontend interfaces and backend APIs to support scalable web products.",
      "Collaborated with designers and teams to deliver performant, user-focused digital solutions.",
      "Researched and experimented with early AI technologies to improve internal development processes.",
    ],
  },
  {
    title: "React Native Intern",
    company: "SGOD",
    time: "Apr 2024 - Jun 2024",
    description: [
      "Participated in the development of an E-Learning app.",
      "Designed UI, developed, programmed, and debugged on both Android and iOS.",
      "Worked closely with Backend team to design APIs and optimize the application.",
    ],
  },
  {
    title: "FrontEnd Intern",
    company: "DHSOFT",
    time: "Dec 2023 - Mar 2024",
    description: [
      "Utilized assigned frontend tasks to enhance user interface and experience.",
      "Developed and implemented various functionalities for an ERP application.",
      "Troubleshooted and resolved bugs within the website.",
    ],
  },
];
